import { Person } from "../person/Person"
import { buildLandPlot, Landplot } from "./Landplot"
import { Organisation } from "./Organisation"

export class FarmerGroup {
    plots: Landplot[]
    person: Person

    constructor(f: any) {
        this.plots = f.plots.map(p => buildLandPlot(p))
        this.person = Person.build(f.person)
    }

    static build(f: any): FarmerGroup {
        return new FarmerGroup(f)
    }

    plotsSize(): number {
        return this.plots.reduce((acc, p) => acc + (p.size ?? 0), 0)
    }
}

export class GroupModel {
    id: number
    name: string
    plots: Landplot[]
    farmers: FarmerGroup[]
    isPuclicVisible: boolean
    delta: number
    org?: Organisation

    constructor(d: any) {
        this.id = d.group_id
        this.name = d.group_name
        this.plots = d.plots?.map(p => buildLandPlot(p))
        this.farmers = this.buildFarmers()
        this.isPuclicVisible = d.isPublicVisible ?? d.is_public
        this.delta = d.group_delta_boost
        this.org = Organisation.build({
            id: d.organisation_id,
            name: d.organisation_name
        })
    }

    buildFarmers(): FarmerGroup[] {
        const map = new Map<number, FarmerGroup>()
        this.plots?.forEach(p => {
            if (p?.owner) {
                const f = map.get(p?.owner?.id)
                if (f) {
                    map.set(p.owner.id, FarmerGroup.build({ plots: [...f.plots, p], person: p.owner }))
                } else {
                    map.set(p.owner.id, FarmerGroup.build({ plots: [p], person: p.owner }))
                }
            }
        })

        return [...map.values()]
    }

    plotsNumber(): number {
        return this.plots.length
    }

    static buildGroup(d: any): GroupModel {
        return new GroupModel(d)
    }

    static buildGroups(g: any) {
        const groups: GroupModel[] = g?.map(group => {
            return GroupModel.buildGroup(group)
        })
        return groups?.sort((a, b) => a.name.toLocaleLowerCase().localeCompare(b.name.toLocaleLowerCase()))
    }
}

